export function marketsExchangeInfoTransform(data) {
    data.Data = data.Data || {};
    return data.Data.ExchangeInfo || {};
}
